import React, { useState } from "react"
import Dropdown from "../DropDown"

export const jobs = [
  { id: 0, title: "-" },
  { id: 1, title: "ورزشکار" },
  { id: 2, title: "مربی تربیت بدنی" },
  { id: 3, title: "تاریخ / جغرافیا / باستان شناسی" },
  { id: 4, title: "روانشناسی" },
  { id: 5, title: "علوم اجتماعی" },
  { id: 6, title: "راهنمای تور / مهماندار" },
  { id: 7, title: "ایمنی و امنیت" },
  { id: 8, title: "خبرنگار و روزنامه نگار" },
  { id: 9, title: "حقوقدان" },
  { id: 10, title: "وکیل" },
  { id: 11, title: "مهندسی انرژی" },
  { id: 12, title: "مهندسی نساجی" },
  { id: 13, title: "مهندسی کشاورزی" },
  { id: 14, title: "مهندسی معدن" },
  { id: 15, title: "مهندسی مواد و متالورژی" },
  { id: 16, title: "زمین شناسی" },
  { id: 17, title: "ترجمه - تولید و ویرایش محتوا" },
  { id: 18, title: "مهندسی صنایع غذایی" },
  { id: 19, title: "مهندسی شیمی" },
  { id: 20, title: "مهندسی نفت و گاز" },
  { id: 21, title: "مهندسی مکانیک" },
  { id: 22, title: "مهندسی هوا و فضا" },
  { id: 23, title: "مهندسی پزشکی" },
  { id: 24, title: "مهندسی برق" },
  { id: 25, title: "مهندسی عمران" },
  { id: 26, title: "مهندسی معماری و شهرسازی" },
  { id: 27, title: "طراحی و گرافیک" },
  { id: 28, title: "پژوهش" },
  { id: 29, title: "منابع انسانی" },
  { id: 30, title: "مدیرعامل" },
  { id: 31, title: "مدیر اجرایی" },
  { id: 32, title: "روابط عمومی" },
  { id: 33, title: "مسئول دفتر" },
  { id: 34, title: "مالی و حسابداری" },
  { id: 35, title: "مهندسی صنایع" },
  { id: 36, title: "مدیریت پروژه" },
  { id: 37, title: "حمل و نقل" },
  { id: 38, title: "انبارداری" },
  { id: 39, title: "بازرگانی" },
  { id: 40, title: "مدیریت شبکه - پشتیبانی سخت افزاری" },
  { id: 41, title: "توسعه نرم افزار و برنامه نویسی" },
  { id: 42, title: "پزشکی" },
  { id: 43, title: "دامپزشکی" },
  { id: 44, title: "پرستاری" },
  { id: 45, title: "زیست شناسی" },
  { id: 46, title: "داروسازی" },
  { id: 47, title: "مدرس" },
  { id: 48, title: "دیجیتال مارکتینگ" },
  { id: 49, title: "فروش / بازاریابی" },
]

export default ({ show, toggleShow, onSubmit, value = {} }) => {
  const prevJob = jobs.find(x => x.id === value.id)
  const [job, setJob] = useState(prevJob);
  return (
    show ? <div className={`modal flexed fl-c full`}>
      <div className={`p-45 bg-top-nav w-40 shadow-mild radius-8 popIn`}>
        <h3 className="m-0 text-shadow font-16 px-8">انتخاب شغل</h3>
        <hr className="mb-0" />
        <form action="" onSubmit={(e) => {
          e.preventDefault();
          onSubmit(job);
          toggleShow(false);
        }}>
          <div className="px-32 pt-24 pb-16 modal-content" style={{ overflow: "visible" }}>
            <div className="grid" style={{ gridTemplateColumns: '1fr 4fr 1fr', gap: 16 }}>
              <div></div>
              <Dropdown items={jobs} selectedItem={job} onItemClick={(e) => setJob(e)} name="شغل" />
              <div></div>
            </div>
          </div>
          <div className="ltr mt-32 px-8">
            <button className="bd-none bg-tomato iran-sans radius-4 font-10 text-top-nav"
              style={{ width: 85, padding: '5px 0' }}>ثبت</button>
            <button className="bd-none bg-none icon-button iran-sans radius-4 font-10 text-top-nav ml-16"
              onClick={() => toggleShow(false)}
              style={{ color: '#ffb1ccbb', padding: '5px 0', width: 85, border: '1px solid #ffb1ccbb' }}
              type="button">بازگشت</button>
          </div>
        </form>
      </div>
    </div> : <div></div>
  )
}
